module.exports = __webpack_public_path__ + "static/img/img-wireframe-1.986b10c3.png";